module.exports = __webpack_public_path__ + "static/media/17CO135.cb219154.jpg";